import { readMyLastLocation } from "../constants/locationPermission";

const CACHED_GPS_MAX_AGE_MS = 30 * 60 * 1000;

function toGps(raw) {
  if (!raw) return null;
  const latitude = Number(raw.latitude);
  const longitude = Number(raw.longitude);
  if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) return null;
  if (latitude < -90 || latitude > 90 || longitude < -180 || longitude > 180) return null;
  const accuracy = Number(raw.accuracy);
  return {
    latitude,
    longitude,
    accuracy: Number.isFinite(accuracy) ? accuracy : null,
  };
}

/** Last fix from the live location tracker, used when a fresh GPS read times out. */
function cachedGps() {
  const saved = readMyLastLocation();
  const gps = toGps(saved);
  if (!gps) return null;
  const at = saved?.updatedAt ? new Date(saved.updatedAt).getTime() : 0;
  if (!at || Date.now() - at > CACHED_GPS_MAX_AGE_MS) return null;
  return gps;
}

export function captureCurrentGps(timeoutMs = 12000) {
  return new Promise((resolve) => {
    const fallback = () => resolve(cachedGps());
    if (typeof navigator === "undefined" || !navigator.geolocation) {
      fallback();
      return;
    }
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        const gps = toGps(pos?.coords);
        resolve(gps || cachedGps());
      },
      fallback,
      { enableHighAccuracy: true, timeout: timeoutMs, maximumAge: 20000 }
    );
  });
}
